import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/observatorycities/';
    const pathsList = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'governanceroom/observatorycities/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/observatorycities/delete`
    }

    const list = {
        labelTitle: 'Lista de Municípios - Observatório',
        labelTitleButtonAdd: 'Incluir novo município',
        fieldsShowOnDelete: [''],
        filter: profileFilter,
        canDelete: true,
        columns: [
            {
                name: 'client_name',
                label: 'Cliente do Município'
            },
            {
                name: 'client_city_name',
                label: 'Município'
            }
        ],
        ...pathsList
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;